import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import StudentsList from '@/pages/Students/StudentsList.vue'
import Student from '@/pages/Students/StudentProfile.vue'
import StudentProfile from '@/components/Students/Page/Profile.vue'
import StudentSchedule from '@/components/Students/Page/Schedule.vue'
import {
  USER_ROLE_STUD
} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const students: RouteConfig = {
  path: '/students',
  name: 'students',
  meta: {
    pageName: messages.common.sidebar_links.students.main
  },
  component: DashboardLayout,
  redirect: '/students/list',
  children: [
    {
      path: 'list',
      name: 'studentsList',
      meta: {
        pageName: messages.students.list,
        access: USER_ROLE_STUD
      },
      component: StudentsList,
    },
    {
      path: 'list/page/:page',
      name: 'studentsPage',
      meta: {
        pageName: messages.students.list,
        access: USER_ROLE_STUD
      },
      component: StudentsList
    },
    {
      path: ':id',
      name: 'student',
      meta: {
        pageName: messages.common.sidebar_links.students.page_name
      },
      component: Student,
      props: true,
      redirect: {name: 'studentPage'},
      children: [
        {
          path: 'profile',
          name: 'studentPage',
          meta: {
            pageName: messages.students.profile,
            access: USER_ROLE_STUD
          },
          component: StudentProfile,
          props: true
        },
        {
          path: 'schedule',
          name: 'studentPageSchedule',
          meta: {
            pageName: messages.students.schedule,
            access: USER_ROLE_STUD
          },
          component: StudentSchedule,
          props: true
        }
      ]
    }
  ]
}
export default students